import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Paper,
  Container,
} from "@mui/material";

const TermosPrivacidade = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper 
        elevation={3} 
        sx={{
          padding: 3,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
          Termos de Privacidade da Câmara Municipal de Serra Caiada
        </Typography>
        
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
          Última atualização: 30/10/2023
        </Typography>

        <Typography variant="body1" paragraph>
          Bem-vindo ao site da Câmara Municipal de Serra Caiada. Estamos comprometidos em proteger a sua privacidade 
          e garantir a segurança das suas informações pessoais. Este documento descreve como coletamos, usamos, 
          compartilhamos e protegemos os seus dados pessoais enquanto você navega em nosso site.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>1. Informações Coletadas</Typography>
        <Typography variant="body1" paragraph>
          <strong>Informações Pessoais:</strong> Podemos coletar informações como nome, endereço, telefone e e-mail quando 
          você as fornece voluntariamente ao preencher formulários ou entrar em contato conosco.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Dados de Navegação:</strong> Podemos coletar informações sobre sua visita ao site, incluindo endereço IP, tipo 
          de navegador, páginas visitadas e dados de referência.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>2. Uso de Informações</Typography>
        <Typography variant="body1" paragraph>
          Utilizamos as informações pessoais para responder às suas solicitações, fornecer informações sobre serviços municipais, 
          melhorar nosso site e comunicar eventos ou atualizações relevantes. Dados de navegação são usados para análise e segurança.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>3. Compartilhamento de Informações</Typography>
        <Typography variant="body1" paragraph>
          Não compartilhamos suas informações pessoais com terceiros sem o seu consentimento, a menos que seja exigido por lei.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>4. Cookies e Tecnologias Semelhantes</Typography>
        <Typography variant="body1" paragraph>
          Utilizamos cookies para melhorar a funcionalidade do nosso site. Você pode gerenciar as configurações de cookies no seu navegador.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>5. Segurança de Dados</Typography>
        <Typography variant="body1" paragraph>
          Implementamos medidas de segurança para proteger suas informações contra acessos não autorizados ou uso indevido.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>6. Links para Sites de Terceiros</Typography>
        <Typography variant="body1" paragraph>
          Nosso site pode conter links para sites de terceiros. Não somos responsáveis pelas práticas de privacidade desses sites.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>7. Seus Direitos de Privacidade</Typography>
        <Typography variant="body1" paragraph>
          Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Entre em contato conosco para exercer esses direitos.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>8. Alterações nesta Política</Typography>
        <Typography variant="body1" paragraph>
          Podemos atualizar esta política de privacidade a qualquer momento. Recomendamos que você verifique periodicamente as alterações.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>9. Contato</Typography>
        <Typography variant="body1" paragraph>
          Se tiver dúvidas sobre esta política de privacidade, entre em contato conosco:
        </Typography>
        <Typography variant="body1">
          <strong>Endereço:</strong> R. Nossa Sra. da Conceição, 334, Serra Caiada, RN, CEP: 59245-000
        </Typography>
        <Typography variant="body1">
          <strong>Contato:</strong> (84) 3293-0072
        </Typography>
        <Typography variant="body1">
          <strong>E-mail:</strong> camaraserracaiada@gmail.com
        </Typography>
        <Typography variant="body1">
          <strong>Horário de expediente:</strong> Segunda à Sexta, das 07h00 às 13h00
        </Typography>

        <Box sx={{ mt: 3, textAlign: "center", backgroundColor: theme.palette.primary.main, padding: 2, borderRadius: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" ,color:theme.palette.primary.text}}>
            Ao usar nosso site, você concorda com esta política de privacidade. Se não concordar, por favor, não continue navegando.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermosPrivacidade;
